/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Skip_ContentInputs */

const en_mk_skip_content = /** @type {(inputs: Mk_Skip_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skip to content`)
};

const id_mk_skip_content = /** @type {(inputs: Mk_Skip_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lewati ke konten`)
};

/**
* | output |
* | --- |
* | "Skip to content" |
*
* @param {Mk_Skip_ContentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_skip_content = /** @type {((inputs?: Mk_Skip_ContentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Skip_ContentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_skip_content(inputs)
	return en_mk_skip_content(inputs)
});